<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-card flat>
        <v-card-title>
          Total assigned collection under No Category: {{ totalNoAssignedCount }}
        </v-card-title>
        <v-card-text>
          <v-data-table
            fixed-header
            :items="layoutData.complex.items"
            :headers="layoutData.complex.headers"
            :loading="layoutData.complex.loading"
            height="650"
          >
            <template v-slot:item.action="{ item }">
              <v-tooltip right>
                <template v-slot:activator="{ on }">
                </template>
                <span>Detail</span>
              </v-tooltip>
              <v-btn
                small
                color="primary"
                @click="actionEvent(item)"
              >
                <v-icon>drag_indicator</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="dialog.display" persistent max-width="60%">
      <arb-basic-card v-if="dialog.display" :title="dialog.title">
        <v-icon slot="widget-header-action" @click="hideDialogEvent">close</v-icon>
        <div slot="widget-content">
          <v-layout justify-center wrap>
            <v-flex lg5>
              <v-data-table
                v-model="dialog.complex.loanSelected"
                :headers="dialog.complex.loanHeaders"
                :items="dialog.complex.loanItems"
                item-key="id"
                :loading="dialog.loading"
                show-select
                class="p-t-5"
              ></v-data-table>
            </v-flex>
            <v-flex align-self-center lg1>
              <v-btn icon class="m-l-30">
                <v-icon>keyboard_double_arrow_right</v-icon>
              </v-btn>
            </v-flex>
            <v-flex lg6>
              <v-data-table
                v-model="dialog.complex.employeeSelected"
                :headers="dialog.complex.employeeHeaders"
                :items="dialog.complex.employeeItems"
                item-key="id"
                :loading="dialog.loading"
                show-select
                class="p-t-5"
              >
                <template v-slot:item.employeeName="{ item }">
                  {{ assist.tool.getFullName(item) }}
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
        <template slot="widget-footer-enter">
          <v-btn
            text
            @click="hideDialogEvent"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="reassignmentLoan"
          >
            Reassign Collection
          </v-btn>
        </template>
      </arb-basic-card>
    </v-dialog>
  </div>
</template>

<script>
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import { DataType, Tool, Popup } from '@/util/index'
import { PaymentApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  data () {
    return {
      assist: {
        dataType: DataType,
        tool: tool
      },
      totalNoAssignedCount: 0,
      roleId: 54,
      layoutData: {
        loading: false,
        complex: {
          headers: LIST_TABLE_HEADER.COLLECTION_MANAGEMENT_HEADER,
          items: []
        }
      },
      dialog: {
        display: false,
        title: 'Collection Management',
        loading: false,
        complex: {
          loanHeaders: LIST_TABLE_HEADER.REASSIGN_COLLECTION_HEADER.LOAN,
          loanItems: [],
          loanSelected: [],
          employeeHeaders: LIST_TABLE_HEADER.REASSIGN_COLLECTION_HEADER.EMPLOYEE,
          employeeItems: [],
          employeeSelected: []
        }
      }
    }
  },
  watch: {
    '$store.getters.getRuntimePortfolio': {
      handler (newVal, oldVal) {
        if (tool.compareTwoPortfolioArray(newVal, oldVal)) {
          this.getCollectionManagementQueueData()
        }
      }
    }
  },
  mounted () {
    this.getCollectionManagementQueueData()
  },
  methods: {
    actionEvent (item) {
      this.getCollectionManagementLoanData(item.assignedId)
      this.dialog.display = true
    },
    hideDialogEvent () {
      this.dialog.display = false
    },
    isELLAndWSLOnly (runtimePortfolio) {
      const res = runtimePortfolio.find(item => {
        return item !== 7 && item !== 8
      })
      return tool.isEmpty(res)
    },
    getCollectionManagementQueueData () {
      const $this = this
      const runtimePortfolio = $this.$store.getters.getRuntimePortfolio
      if (tool.isEmpty(runtimePortfolio)) {
        return
      }
      if (!this.isELLAndWSLOnly(runtimePortfolio)) {
        $this.layoutData.complex.items = []
        $this.totalNoAssignedCount = 0
        popup.popupForWarning('Portfolio can only choose ELL and WSL')
        return
      }

      $this.layoutData.loading = true
      const requestData = {
        roleId: $this.roleId
      }
      PaymentApi.getCollectionManagementQueueData(requestData, function (result) {
        result = tool.isNotEmpty(result) ? result : []
        $this.layoutData.loading = false
        $this.layoutData.complex.items = result
        let totalNoAssignedCount = 0
        result.map(item => {
          totalNoAssignedCount += item.count
        })
        $this.totalNoAssignedCount = totalNoAssignedCount
      }, function () {
        $this.layoutData.loading = false
        $this.layoutData.complex.items = []
        $this.totalNoAssignedCount = 0
      })
    },
    getCollectionManagementLoanData (assignedId) {
      const $this = this
      $this.dialog.loading = true
      $this.dialog.complex.employeeSelected = []
      $this.dialog.complex.loanSelected = []
      const requestData = {
        assignedId: assignedId,
        roleId: $this.roleId
      }
      PaymentApi.getCollectionManagementLoanData(requestData, function (result) {
        result = tool.isNotEmpty(result) ? result : {}
        $this.dialog.complex.loanItems = tool.isNotEmpty(result.loans) ? result.loans : []
        $this.dialog.complex.employeeItems = tool.isNotEmpty(result.employees) ? result.employees : []
        $this.dialog.loading = false
      }, function () {
        $this.dialog.complex.loanItems = []
        $this.dialog.complex.employeeItems = []
        $this.dialog.loading = false
      })
    },
    reassignmentLoan () {
      const $this = this
      const selectedEmployee = $this.dialog.complex.employeeSelected
      const selectedLoan = $this.dialog.complex.loanSelected
      if (tool.isEmpty(selectedEmployee)) {
        popup.popupForWarning('No employee selected')
        return false
      }
      if (tool.isEmpty(selectedLoan)) {
        popup.popupForWarning('No loan selected')
        return false
      }

      const loanIds = []
      const assignedIds = []
      selectedLoan.map(item => {
        loanIds.push(item.id)
      })
      selectedEmployee.map(item => {
        assignedIds.push(item.id)
      })

      const requestData = {
        loanIds: loanIds,
        assignedIds: assignedIds
      }
      PaymentApi.reassignmentLoan(requestData, function () {
        popup.popupForSuccess('Success to reassign collection')
        $this.dialog.display = false
        $this.getCollectionManagementQueueData()
      }, function (result) {
        popup.popupForError(result.message)
      })
    }
  }
}
</script>
